import PolicyEditor from './PolicyEditor';

export default PolicyEditor;
